exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin8-bottom[data-v-5858fdd6] {\n  margin-bottom: 0.4rem;\n}\n.padding0-5 > div[data-v-5858fdd6] {\n  border-radius: 0.4rem;\n  margin-bottom: 0.4rem;\n  overflow: hidden;\n}\n.isiphoneX[data-v-5858fdd6] {\n  padding-bottom: 1rem;\n}\n.certifications[data-v-5858fdd6] {\n  text-align: center;\n}\n.certifications a[data-v-5858fdd6] {\n  font-size: 0.6rem;\n  color: #00ab84;\n}", ""]);

// exports
